// extracted by mini-css-extract-plugin
export default {"files":"UploadComponent_files__6K+sP","icon":"UploadComponent_icon__H57nR","link":"UploadComponent_link__BdnLA"};